import React from 'react';
import { useParams } from 'react-router-dom';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { Partner, TripMatch } from '@marageti/z4-sdk/lib/travel';
import SubNavigationTripMatchView from './trip-match-sub-navigation-view';
import { TabItem } from '../sub-navigation/types';

const TRIP_LINKS: TabItem[] = [
  {
    e2e: 'ztest-trip-match-tab-about',
    label: 'about',
    to: '',
  },
  {
    e2e: 'ztest-trip-match-tab-messages',
    label: 'messages',
    to: 'messages',
  },
  {
    e2e: 'ztest-trip-match-tab-documents',
    label: 'documents',
    to: 'documents',
  },
];

const SubNavigationTripMatchContainer = () => {
  const { tripMatchId } = useParams();
  const apiClient = useApiClient();

  const { data: tripMatch } = useFetch<TripMatch>(apiClient.tripMatchesClient.getTripMatch, [tripMatchId], !!tripMatchId);
  const { data: partner } = useFetch<Partner>(apiClient.partnersClient.getPartner, [tripMatch?.partnerId], !!tripMatch?.partnerId);

  return (
    <SubNavigationTripMatchView
      tripMatch={tripMatch}
      partner={partner}
      tabs={TRIP_LINKS}
    />
  );
};

export default SubNavigationTripMatchContainer;
